import { creatorbase } from '@round/api';
import { FormValues } from 'Modules/Plans/Finance/PaymentRequest/helpers';

export const mapFormValuesToCampaignPatchData = (
    formValues: FormValues,
    feeConfigs?: creatorbase.ClientProviderFeeConfig[]
): Partial<creatorbase.PatchCampaignBody> => {
    const provider = formValues.provider;
    return {
        base_cost: formValues.cost,
        currency_id: formValues.currency?.value,
        payment_info: {
            paypal_email_address: provider === 'PAYPAL' ? formValues.paypalEmail : undefined,
            client_payee_id: provider === 'TIPALTI' ? formValues.payee?.value : undefined,
            notes: formValues.notes ?? '',
        },
        fee_config_id: feeConfigs?.find((feeConfig) => feeConfig.provider_name === provider)?.provider_fee_config_id,
        creator_agency_payee_id: provider === 'CREATOR_AGENCY' ? formValues.agencyPayee?.value : undefined,
        payment_request_file_upload: formValues.fileUpload,
    };
};
